import { configureStore } from '@reduxjs/toolkit'
import authSlice from './authSlice'
import importSlice from './importSlice'
import organizationSlice from './organizationSlice'
import teamMatchCacheSlice from './teamMatchCacheSlice'

export const store = configureStore({
  reducer: {
    auth: authSlice,
    import: importSlice,
    organization: organizationSlice,
    teamMatchCache: teamMatchCacheSlice,
  },
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

// Timezone selectors
export const selectUserTimezone = (state: RootState) => state.auth.user?.timezone;
export const selectOrganizationTimezone = (state: RootState) => state.organization.settings?.timezone;
export const selectEffectiveTimezone = (state: RootState) => {
  const userTz = selectUserTimezone(state);
  const orgTz = selectOrganizationTimezone(state);
  
  // If user has explicitly set a timezone (not null), use it
  if (userTz) {
    return userTz;
  }
  
  // If user timezone is null (default), follow organization timezone
  if (orgTz) {
    return orgTz;
  }
  
  // Final fallback
  return 'UTC';
};
